
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/v20/streaming/heartbeat_enable",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/v20/streaming/heartbeat_enable/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/v20/streaming/heartbeat_enable"])
      });
    }
  